module.exports = __webpack_public_path__ + "static/media/logo.544d7810.png";